import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const YupGenerateCoupon = () => {
  //page hook
  const { t } = useTranslation();
  return {
    couponFamilyId: Yup.string().required(
      t("validation.required", {
        couponFamilyId: t("page.couponFamilyId"),
      }) || ""
    ),
    date: Yup.array()
      .length(2)
      .required(
        t("validation.required", {
          date: t("page.date"),
        })
      ),
    userId: Yup.string().required(
      t("validation.required", {
        userId: t("page.userId"),
      })
    ),
    serviceCategory:Yup.string().required(
      t("validation.required", {
        serviceCategory: t("page.service_category"),
      })
    ),
  };
};
